import { defineMessages } from 'react-intl';

export default defineMessages({
    appName: {
        id: 'ac.portal.name',
        defaultMessage: 'CustomerEngage Account Management',
    },
    account: {
        id: 'ac.portal.index.Account',
        defaultMessage: 'Account',
    },
    faq: {
        id: 'ac.portal.index.FAQ',
        defaultMessage: 'FAQ',
    },
    home: {
        id: 'ac.app.html.index.Home',
        defaultMessage: 'Home',
    },
    logout: {
        id: 'ac.portal.index.Logout',
        defaultMessage: 'Logout',
    },
    additionalEnrollment: {
        id: 'ac.portal.index.Link a Policy',
        defaultMessage: 'Link a Policy',
    },
    makeAPayment: {
        id: 'ac.portal.index.Make a Payment',
        defaultMessage: 'Make a Payment',
    },
    billingSummary: {
        id: 'ac.portal.index.Billing',
        defaultMessage: 'Billing',
    },
    claimList: {
        id: 'ac.portal.index.Claims',
        defaultMessage: 'Claims',
    },
    claimDetails: {
        id: 'ac.portal.index.Claim Details',
        defaultMessage: 'Claim Details',
    },
    createNote: {
        id: 'ac.portal.index.Create Note',
        defaultMessage: 'Create Note',
    },
    policyChange: {
        id: 'ac.portal.index.Policy Change',
        defaultMessage: 'Policy Change',
    },
    offerDetails: {
        id: 'ac.portal.index.Offer Details',
        defaultMessage: 'Offer Details',
    },
    policyDetails: {
        id: 'ac.portal.index.Policy Details',
        defaultMessage: 'Policy Details',
    },
    accountInformation: {
        id: 'ac.portal.index.Account Information',
        defaultMessage: 'Account Information',
    },
    homePage: {
        id: 'ac.portal.index.Home Page',
        defaultMessage: 'Home Page',
    },
    error: {
        id: 'ac.portal.index.Error',
        defaultMessage: 'Error',
    },
    errorMessage: {
        id: 'ac.portal.index.Sorry, an error occurred. You can try later or contact one of our agents.',
        defaultMessage:
            'Sorry, an error occurred. You can try later or contact one of our agents.',
    },
    errorMetadataMessage: {
        id: 'ac.portal.index.No product metadata please refer to README for building metadata.',
        defaultMessage:
            'No product metadata please refer to README for building metadata.',
    },
    backButton: {
        id: 'ac.portal.index.Back',
        defaultMessage: 'Back',
    },
    managePaymentMethods: {
        id: 'portal.index.Manage Payment Methods',
        defaultMessage: 'Manage Payment Methods'
    },
    signup: {
        id: 'portal.index.Signup Title',
        defaultMessage: 'New User Registration and Enrollment'
    },
    help: {
        id: 'portal.index.Help',
        defaultMessage: 'Help'
    },
    addAccountSecurity: {
        id: 'portal.index.Add Account Security',
        defaultMessage: 'Add Account Security'
    },
    bannerContactAgent: {
        id: 'portal.index.Please contact your agant',
        defaultMessage: ' Please contact your agent for more details.'
    }
});
